export default function FormItem({
  label,
  htmlFor,
  className,
  children,
  helpText,
}) {
  return (
    <div className={`flex flex-col ${className ? className : ''}`}>
      <label className="font-bold text-xs ml-5 text-gray-500" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {helpText && <p className="text-xs text-gray-500 ml-5">{helpText}</p>}
    </div>
  );
}
